import { OutputTypeEnum } from 'entities/financeOperations/types';
import { CitiesListType } from 'features/getCities/types';
import { CityType } from 'shared/types';

export const mapTypeOutputToText = (type: string): string => {
  switch (type) {
    case OutputTypeEnum.PHONE:
      return 'По номеру телефона';
    case OutputTypeEnum.CARD:
      return 'На карту';
    case OutputTypeEnum.BANK_ACCOUNT:
      return 'На банк';
    case OutputTypeEnum.YURTA_WALLET:
      return 'На Юрту';

    case OutputTypeEnum.BEELINE:
      return 'По номеру телефона, Beeline';
    case OutputTypeEnum.MOBIUZ:
      return 'По номеру телефона, Mobiuz';
    case OutputTypeEnum.OQ:
      return 'По номеру телефона, OQ';
    case OutputTypeEnum.OSON_WALLET:
      return 'Кошелёк OSON';
    case OutputTypeEnum.PERFECTUM:
      return 'По номеру телефона, Perfectum';
    case OutputTypeEnum.UCELL:
      return 'По номеру телефона, Ucell';
    case OutputTypeEnum.UZMOBILE_CDMA:
      return 'По номеру телефона, Uzmobile_CDMA';
    case OutputTypeEnum.UZMOBILE_GSM:
      return 'По номеру телефона, Uzmobile_GSM';
    default:
      return '---';
  }
};

export const countCitiesToText = (
  financeOperatorCountry: string | undefined,
  financeOperatorCities: number[] | undefined,
  cities: CitiesListType[] | undefined,
  cachedCities: Record<number, CityType>,
) => {
  if (!financeOperatorCountry || !financeOperatorCities || !cities) {
    return;
  }

  if (financeOperatorCities.length === cities.length) {
    return `Весь ${financeOperatorCountry}`;
  }
  return financeOperatorCities.map((id) => cachedCities[id]?.name).join(', ');
};
